var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-form",
    [
      _c(
        "sui-grid",
        [
          _c(
            "sui-grid-row",
            { attrs: { centered: "" } },
            [
              _c(
                "sui-grid-column",
                { attrs: { centered: "", width: 10 } },
                [
                  _c(
                    "sui-form-fields",
                    { attrs: { "equal-width": "" } },
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("First Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.first_name,
                              expression: "user.first_name",
                            },
                          ],
                          attrs: { type: "text", name: "first_name" },
                          domProps: { value: _vm.user.first_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user,
                                "first_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", { staticClass: "required field" }, [
                        _c("label", [_vm._v("Last Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.last_name,
                              expression: "user.last_name",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "last_name",
                            placeholder: "Last Name",
                          },
                          domProps: { value: _vm.user.last_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user,
                                "last_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-fields",
                    { attrs: { "equal-width": "" } },
                    [
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Email")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.email,
                              expression: "user.email",
                            },
                          ],
                          attrs: { type: "email", name: "email" },
                          domProps: { value: _vm.user.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.user, "email", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Mobile")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.mobile_phone,
                              expression: "user.profile.mobile_phone",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "mobile",
                            placeholder: "(xxx) xxx-xxxx",
                          },
                          domProps: { value: _vm.user.profile.mobile_phone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "mobile_phone",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-fields",
                    { attrs: { "equal-width": "" } },
                    [
                      _c(
                        "sui-form-field",
                        [
                          _c(
                            "sui-form-fields",
                            [
                              _c(
                                "sui-form-field",
                                { attrs: { width: "ten" } },
                                [
                                  _c("label", [_vm._v("Phone")]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.user.profile.phone,
                                        expression: "user.profile.phone",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      name: "phone",
                                      placeholder: "(xxx) xxx-xxxx",
                                    },
                                    domProps: { value: _vm.user.profile.phone },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.user.profile,
                                          "phone",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "sui-form-field",
                                { attrs: { width: "six" } },
                                [
                                  _c("label", [_vm._v("Ext.")]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.user.profile.phone_extension,
                                        expression:
                                          "user.profile.phone_extension",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      name: "phone_extension",
                                      placeholder: "Ext.",
                                    },
                                    domProps: {
                                      value: _vm.user.profile.phone_extension,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.user.profile,
                                          "phone_extension",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Fax")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profile.fax,
                              expression: "user.profile.fax",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "fax",
                            placeholder: "Fax",
                          },
                          domProps: { value: _vm.user.profile.fax },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user.profile,
                                "fax",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-fields",
                    [
                      _vm.authUser.is_admin ||
                      _vm.authUser.profile.is_super_admin
                        ? _c(
                            "sui-form-field",
                            { attrs: { required: "", width: "eight" } },
                            [
                              _c("label", [_vm._v("Profile Type")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  name: "profile-type",
                                  placeholder: "Profile",
                                  floating: "",
                                  selection: "",
                                  search: "",
                                  options: _vm.profileTypes,
                                },
                                model: {
                                  value: _vm.user.profile.profile_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.user.profile,
                                      "profile_type",
                                      $$v
                                    )
                                  },
                                  expression: "user.profile.profile_type",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-fields",
                    [
                      _vm.authUser.profile.is_super_admin
                        ? _c(
                            "sui-form-field",
                            { attrs: { required: "", width: "eight" } },
                            [
                              _c("label", [_vm._v("Firm")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Firm",
                                  selection: "",
                                  search: "",
                                  floating: "",
                                  options: _vm.firms,
                                },
                                model: {
                                  value: _vm.user.profile._firm,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user.profile, "_firm", $$v)
                                  },
                                  expression: "user.profile._firm",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.authUser.is_admin ||
                      _vm.authUser.profile.is_super_admin
                        ? _c(
                            "sui-form-field",
                            { attrs: { width: "eight" } },
                            [
                              _c("label", [_vm._v("Financial Advisor")]),
                              _c("sui-dropdown", {
                                attrs: {
                                  placeholder: "Financial Advisor",
                                  selection: "",
                                  search: "",
                                  floating: "",
                                  options: _vm.advisors,
                                },
                                model: {
                                  value: _vm.user.advisor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user, "advisor", $$v)
                                  },
                                  expression: "user.advisor",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.authUser.is_admin || _vm.authUser.profile.is_super_admin
                    ? _c(
                        "sui-form-fields",
                        { attrs: { "equal-width": "" } },
                        [
                          _c(
                            "sui-form-field",
                            [
                              _c("sui-checkbox", {
                                attrs: {
                                  name: "system-admin",
                                  label: "System Administrator",
                                },
                                model: {
                                  value: _vm.user.is_admin,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user, "is_admin", $$v)
                                  },
                                  expression: "user.is_admin",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "sui-form-field",
                            [
                              _c("sui-checkbox", {
                                attrs: { name: "cco", label: "CCO" },
                                model: {
                                  value: _vm.user.profile.is_cco,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user.profile, "is_cco", $$v)
                                  },
                                  expression: "user.profile.is_cco",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.authUser.profile.is_super_admin
                    ? _c(
                        "sui-form-fields",
                        { attrs: { "equal-width": "" } },
                        [
                          _c(
                            "sui-form-field",
                            [
                              _c("sui-checkbox", {
                                attrs: {
                                  name: "super-system-admin",
                                  label: "Super System Administrator",
                                },
                                model: {
                                  value: _vm.user.profile.is_super_admin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.user.profile,
                                      "is_super_admin",
                                      $$v
                                    )
                                  },
                                  expression: "user.profile.is_super_admin",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "sui-form-field",
                            [
                              _c("sui-checkbox", {
                                attrs: {
                                  name: "super-cco",
                                  label: "Super CCO",
                                },
                                model: {
                                  value: _vm.user.profile.is_super_cco,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.user.profile,
                                      "is_super_cco",
                                      $$v
                                    )
                                  },
                                  expression: "user.profile.is_super_cco",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("sui-divider"),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [_vm._v("Forms")]),
                    _c(
                      "div",
                      [
                        _c(
                          "sui-form-field",
                          { staticStyle: { "margin-left": "1em" } },
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label:
                                  "Exhibit B - Investor Profile Form (Don’t use if private assets are held.)",
                              },
                              model: {
                                value:
                                  _vm.user.profile
                                    .is_exhibit_b_investor_profile_form_user,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.user.profile,
                                    "is_exhibit_b_investor_profile_form_user",
                                    $$v
                                  )
                                },
                                expression:
                                  "user.profile.is_exhibit_b_investor_profile_form_user",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-divider"),
                  _c(
                    "sui-form-fields",
                    { attrs: { grouped: "" } },
                    [
                      _c("label", [_vm._v("Custodians")]),
                      _c(
                        "sui-form-field",
                        { staticClass: "custodian" },
                        [
                          _c("sui-checkbox", {
                            attrs: { label: "Fidelity" },
                            model: {
                              value: _vm.user.profile.is_using_fidelity,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user.profile,
                                  "is_using_fidelity",
                                  $$v
                                )
                              },
                              expression: "user.profile.is_using_fidelity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        { staticClass: "custodian" },
                        [
                          _c("sui-checkbox", {
                            attrs: { label: "National Advisors Trust" },
                            model: {
                              value:
                                _vm.user.profile
                                  .is_using_national_advisors_trust,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user.profile,
                                  "is_using_national_advisors_trust",
                                  $$v
                                )
                              },
                              expression:
                                "user.profile.is_using_national_advisors_trust",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        { staticClass: "custodian" },
                        [
                          _c("sui-checkbox", {
                            attrs: { label: "Schwab" },
                            model: {
                              value: _vm.user.profile.is_using_schwab,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user.profile,
                                  "is_using_schwab",
                                  $$v
                                )
                              },
                              expression: "user.profile.is_using_schwab",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        { staticClass: "custodian" },
                        [
                          _c("sui-checkbox", {
                            attrs: { label: "TD Ameritrade" },
                            model: {
                              value: _vm.user.profile.is_using_td_ameritrade,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.user.profile,
                                  "is_using_td_ameritrade",
                                  $$v
                                )
                              },
                              expression: "user.profile.is_using_td_ameritrade",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("sui-divider"),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        staticStyle: { "font-style": "italic !important" },
                        attrs: {
                          label:
                            "Generate new password and notify user immediately",
                        },
                        model: {
                          value: _vm.notifyUser,
                          callback: function ($$v) {
                            _vm.notifyUser = $$v
                          },
                          expression: "notifyUser",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }